import { initialize as InitializeLAO } from "./dashboards/LAO/Main";
import { initialize as InitializeTEO } from "./dashboards/TEO/Main";
import { initialize as InitializeTrace } from "./dashboards/TRACE/Main";

import { initialize as InitializeMyWork } from "./dashboards/MYWORK/Main";
import { initialize as InitializeNOO } from "./dashboards/NOO/Main";
import { initialize as InitializeExport } from "./dashboards/EXPORT/Main";



function initializeDashboards() {
    console.log("Initializing dashboard");
    InitializeTEO();
    InitializeLAO();
    InitializeTrace();
    InitializeMyWork();
    InitializeNOO();
    InitializeExport();
}

initializeDashboards();
